import {
  ConsultantContractPayoutType,
  ConsultantContractType,
  ContractType
} from "@bonliva-crm/graphql";
import * as yup from "yup";
import { ContractUnion } from "../types";

export type UploadSignedDocumentFormValues = {
  file: File | null;
  date?: Date | null;
  contract: ContractUnion;
  contractType?: ContractType;
  payoutType?: ConsultantContractPayoutType;
  bankCounselling?: boolean;
  expectedSalary?: string | null;
};

export const uploadSignedDocumentFormSchema = yup.object({
  file: yup.mixed().required(),
  contract: yup.object().required(),
  date: yup.date().when("contract", {
    is: (contract: ContractUnion) =>
      [
        ConsultantContractType.Intermittent,
        ConsultantContractType.Intermittent_National,
        ConsultantContractType.Framework_National
      ].includes(contract.Type as ConsultantContractType),
    then: (y) => y.required(),
    otherwise: (y) => y.nullable(true)
  }),
  contractType: yup
    .mixed()
    .oneOf([...Object.values(ContractType)])
    .when("contract", {
      is: (contract: ContractUnion) =>
        [ConsultantContractType.Intermittent, ConsultantContractType.Employment].includes(
          contract.Type as ConsultantContractType
        ),
      then: (y) => y.required(),
      otherwise: (y) => y.nullable(true)
    }),
  payoutType: yup
    .mixed()
    .oneOf([...Object.values(ConsultantContractPayoutType)])
    .when("contract", {
      is: (contract: ContractUnion) =>
        [
          ConsultantContractType.Intermittent,
          ConsultantContractType.Employment,
          ConsultantContractType.Employment_National,
          ConsultantContractType.Intermittent_National
        ].includes(contract.Type as ConsultantContractType),
      then: (y) => y.required(),
      otherwise: (y) => y.nullable(true)
    }),
  bankCounselling: yup.boolean().when("contractType", {
    is: (contractType: ContractType) => contractType === ContractType.Hourly,
    then: (y) => y.required(),
    otherwise: (y) => y.nullable(true)
  }),
  expectedSalary: yup.string().when(["contractType", "contract"], {
    is: (contractType: ContractType, contract: ContractUnion) =>
      contractType === ContractType.HourlyPensionInsurance &&
      contract &&
      [ConsultantContractType.Intermittent, ConsultantContractType.Employment].includes(
        contract.Type as ConsultantContractType
      ),
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.nullable(true)
  })
});
